import { Navigate, Outlet } from 'react-router-dom';
import { RoutePaths } from './RoutePaths';
import { ToolsPageLayout } from '../components';
import { useAppDispatch, useAppSelector, isLoggedIn } from '../base';
import { userActions, userSelectors } from '../actions';
import { LoadingPage } from '../pages';

const ToolsLayout = () => {
    const dispatch = useAppDispatch();
    const isAuthenticated = isLoggedIn();
    const myUser = useAppSelector(userSelectors.getMyUser);

    if (isAuthenticated && !myUser) {
        dispatch(userActions.fetchMyUser());
    }

    const renderAuthenticatedRoute = () => {
        if (!myUser) {
            return <LoadingPage />;
        }
        if (myUser.company?.id) {
            return <Navigate to={RoutePaths.dashboard} replace />;
        }
        return (
            <ToolsPageLayout>
                <Outlet />
            </ToolsPageLayout>
        );
    };

    return isAuthenticated ? (
        renderAuthenticatedRoute()
    ) : (
        <Navigate to={RoutePaths.login} replace />
    );
};

export default ToolsLayout;
